// extracted by mini-css-extract-plugin
export var videoResponsive = "youtubeEmbed-module--videoResponsive--3k7c3";
export var hFull = "youtubeEmbed-module--hFull--2YSQe";